<div
  class="left-sidenav-button-container"
  [class.left-sidenav-button-container--collapsed]="collapsed()">
  <button
    mat-button
    class="left-sidenav-button"
    [class.left-sidenav-button--active]="linkActive()"
    [attr.title]="collapsed() ? sidenavLink().label : null"
    (click)="onButtonClick()">
    @if (linkActive()) {
      <div class="left-sidenav-button-active-indicator"></div>
    }
    <div class="icon-container ac-label ac-flex ac-ctr">
      @if (sidenavLink().iconUrl; as iconUrl) {
        <ac-icon [iconUrl]="iconUrl" [size]="sidenavLink().iconSize ?? 24" class="icon" />
      } @else {
        <ac-icon
          [iconKey]="sidenavLink().iconKey"
          [size]="sidenavLink().iconSize ?? 24"
          class="icon">
        </ac-icon>
      }
    </div>
    @if (!collapsed()) {
      <span class="left-sidenav-label ac-title-md ac-flex-itm-100">{{ sidenavLink().label }}</span>
    }
    @if (!collapsed() && sidenavLink().count !== undefined) {
      <div class="count-badge">
        <span class="count-text">{{ sidenavLink().count }}</span>
      </div>
    }
  </button>

  @if (collapsed()) {
    <span class="left-sidenav-label ac-label-sm" [class.left-sidenav-label--active]="linkActive()">
      {{ sidenavLink().label }}
    </span>

    @if (!!sidenavLink().count) {
      <div class="count-badge count-badge--collapsed">
        <span class="count-text">{{ sidenavLink().count }}</span>
      </div>
    }
  }
</div>
